import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@aqarmap/aqarmap-ui';
import useBreakpoint from '~/hooks/useBreakpoint';
import { useGetUserQuery } from '~/redux/api/userApiSlice';
import { useGetSubscriptionPlansQuery } from '~/redux/api/subscriptionApiSlice';
import { setFooterDisplay } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch } from '~/redux/hooks';
import SubscriptionLoading from '~/pages/Subscription/SubscriptionLoading';
import PlanCard from '~/pages/Subscription/PlanCard';
import { PlanType } from '~/types/subscriptionTypes';
import { UserTypesEnum } from '~/constants/enums';
import '~/pages/Subscription/styles.css';

export default function Subscription() {
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;
  const { mobileScreen } = useBreakpoint();
  const { data: userData, isLoading: isUserLoading } = useGetUserQuery();

  const {
    data: plans,
    isLoading: isPlansLoading,
    isUninitialized: isPlansUninitialized,
  } = useGetSubscriptionPlansQuery(
    { userType: userData?.user?.user_type ?? UserTypesEnum.BUYER, locale },
    {
      skip: isUserLoading,
    },
  );

  useEffect(() => {
    if (mobileScreen) {
      dispatch(setFooterDisplay('hide'));
    }
  }, [mobileScreen]);

  useEffect(() => {
    document.title = `${t('subscriptionPlan')}|${t('aqarmap')}`;
  }, []);

  return (
    <div className="layout-boundary h-full pt-4x pb-[40px] md:pb-[80px]">
      <div className="layout-boundary__inner flex flex-col gap-4x md:gap-6x h-full px-2x md:px-0">
        <div className="flex flex-col gap-1.5x text-center w-full content-center">
          <p className="text-title_2">{t('selectPlane')}</p>
          <p className="text-title-2 text-gray__dark_2">
            {t('selectPlanDescription')}
          </p>
        </div>
        {isPlansLoading || isPlansUninitialized ? (
          <SubscriptionLoading />
        ) : !plans?.length ? (
          <div className="flex flex-col gap-2x items-center justify-center p-2x md:p-4x  h-full md:h-full border border-gray rounded-[8px]">
            <div className="flex element-center w-[80px] h-[80px]">
              <i className="inline-block bg-cover package-icon w-full h-full" />
            </div>
            <p className="text-title_4   text-center">{t('noPlansFound')}</p>
            <Button
              variant="primary"
              size="large"
              onClick={() =>
                (window.location.href = `${process.env.REACT_APP_BASE_URL}/${locale}/`)
              }
            >
              {t('homePage')}
            </Button>
          </div>
        ) : (
          <div
            className={`flex flex-col justify-center md:flex-row h-auto md:h-max gap-3x  md:gap-5x md:flex-wrap
            ${plans?.length === 1 ? 'justify-center' : ' '}
             `}
          >
            {plans?.map((plan: PlanType) => {
              return <PlanCard plan={plan} />;
            })}
          </div>
        )}
      </div>
    </div>
  );
}
